module.exports = __webpack_public_path__ + "img/plant_4_mobile.72df8132.webp";